import { render, staticRenderFns } from "./Kiyaku.vue?vue&type=template&id=2813e19e&scoped=true&"
import script from "./Kiyaku.vue?vue&type=script&lang=js&"
export * from "./Kiyaku.vue?vue&type=script&lang=js&"
import style0 from "./Kiyaku.vue?vue&type=style&index=0&id=2813e19e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813e19e",
  null
  
)

export default component.exports